module.exports = __webpack_public_path__ + "img/关于我们banner.2254437c.png";